import { render, staticRenderFns } from "./ShopTerminalList.vue?vue&type=template&id=604e2031&scoped=true&"
import script from "./ShopTerminalList.vue?vue&type=script&lang=js&"
export * from "./ShopTerminalList.vue?vue&type=script&lang=js&"
import style0 from "./ShopTerminalList.vue?vue&type=style&index=0&id=604e2031&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e2031",
  null
  
)

export default component.exports